// extracted by mini-css-extract-plugin
export default {"grid":"List_grid__L-GZz","itemWrapper":"List_itemWrapper__TW6Lc","item":"List_item__WDrXD"};